function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { extractPureTextFromRichText, Typography } from 'seagull';
import ServiceDescription from "../../../../components/ServiceCreation/ServiceBuilder/ServiceDescription";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { jsx as _jsx } from "react/jsx-runtime";
const ServiceDescriptionCellContent = _ref => {
  let {
    service,
    draft,
    setDraft
  } = _ref;
  const form = useForm({
    mode: 'all',
    defaultValues: {
      description: service.description
    }
  });
  const onChange = description => {
    setDraft(draft.setService(service.id, s => _objectSpread(_objectSpread({}, s), {}, {
      description: JSON.stringify(description)
    })));
  };
  return /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, form), {}, {
    children: /*#__PURE__*/_jsx(ServiceDescription, {
      testId: "edit-service-description-modal",
      hideLabel: true,
      onChange: onChange
    })
  }));
};
export default function ServiceDescriptionCell(_ref2) {
  let {
    index,
    draft,
    service,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref2;
  const onClick = () => {
    onOpenModal({
      shouldSubmit: async draft => {
        var _draft$services$find, _serviceBundles$servi;
        const serviceDescription = (_draft$services$find = draft.services().find(s => s.id === service.id)) === null || _draft$services$find === void 0 ? void 0 : _draft$services$find.description;
        const serviceBundles = draft.serviceBundles().find(b => b.services.find(s => s.id === service.id));
        const serviceBundlesDescription = serviceBundles === null || serviceBundles === void 0 || (_serviceBundles$servi = serviceBundles.services.find(s => s.id === service.id)) === null || _serviceBundles$servi === void 0 ? void 0 : _serviceBundles$servi.description;
        return Promise.resolve(!!serviceDescription && serviceDescription !== service.description || !!serviceBundlesDescription && serviceBundlesDescription !== service.description);
      },
      renderContent: _ref3 => {
        let {
          setDraft
        } = _ref3;
        return {
          title: 'Service description',
          testid: "edit-service-description-modal",
          onSubmit: defaultBehavior => {
            defaultBehavior();
          },
          content: /*#__PURE__*/_jsx(ServiceDescriptionCellContent, {
            service: service,
            draft: draft,
            setDraft: setDraft
          })
        };
      }
    });
  };
  const pureText = useMemo(() => extractPureTextFromRichText(service.description), [service.description]);
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-service-description-".concat(index, "-").concat(draft.id()),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      "data-testid": "service-description-".concat(index, "-").concat(draft.id()),
      ellipsis: true,
      children: pureText
    })
  });
}